import m from "../../geodata/es2015/portugalHigh";
window.am4geodata_portugalHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/portugalHigh.js
// module id = null
// module chunks = 